import { observable } from 'mobx';
import useMount from '../../utils/hooks/use-mount';
import $$tracker from '@src/tracker';
import createHtmlLink from '@src/utils/create-html-link';
import AntdMessage from '@src/components/antd/message';

class FloatRightStore {
  @observable showFloat = false;
  @observable open = true;
  @observable type = 1; // 1-下载 2-预约
  @observable downloadUrl = {};
  @observable FloatQrcode = '';

  openClose = () => {
    this.open = !this.open;
  };

  handleDownload = type => {
    if (type === 'android') {
      $$tracker.clickDownloadAndroid('侧边浮窗');
    } else if (type === 'apple') {
      $$tracker.clickDownloadIOS('侧边浮窗');
    } else if (type === 'pc') {
      $$tracker.clickDownloadPC('侧边浮窗');
    }
    if (this.downloadUrl[type]) {
      let link = createHtmlLink(this.downloadUrl[type]);
      link.target = '_blank';
      link.click();
    } else {
      console.log(type, 'type');
      AntdMessage.error('链接不存在');
    }
  };

  gotoWeb = () => {
    $$tracker.clickGoGw('侧边浮窗');
  };
  gotokF = () => {
    $$tracker.clickLianxikefu();
  };

  use() {
    useMount(() => {
      window.addEventListener('scroll', () => {
        // 兼容不同浏览器
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 500) {
          if (this.showFloat) {
            return;
          }
          this.showFloat = true;
        } else {
          this.showFloat = false;
        }
      });
    });
  }
}
export default FloatRightStore;
